import { Stack } from '@mui/material';

export const ActionRow = ({ children }: { children: React.ReactNode }) => {
  return (
    <Stack direction="row" gap={1.5} alignItems="center" justifyContent="flex-end">
      {children}
    </Stack>
  );
};
